import React from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import WorkingExperienceLayout from './WorkingExperienceLayout';
import '../modal.css';
import './WorkExperienceInfoModal.css'
const WorkExperienceInfoModal = (props) => {
    // const [show, setShow] = useState(false);

  return (
    <>
      {/* <Button variant="primary" onClick={() => setShow(true)}>
        Custom Width Modal
      </Button> */}

      <Modal
        show={props.show}
        size="lg"
        onHide={props.onHide}
        dialogClassName="modal-90w"
        scrollable
        className="workExperienceInfoModal-class"
        aria-labelledby="example-custom-modal-styling-title"
        // style={{ overflow: 'auto'}}
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        {/* <Modal.Dialog scrollable 
      className='PersonalInfoModalDiagram-class' */}

        {/* > */}
        <Modal.Header
          className="modal-header"
          // style={{background: '#AF441C' , paddingTop: '2px', paddingBottom: '2px'}}
          closeButton
        >
          <Modal.Title
            id="example-custom-modal-styling-title"
            style={{ width: "100%", textAlign: "center" }}
          >
            <h2> WORK EXPERIENCE TIMELINE</h2>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="WorkingExperienceInfoModalBody-class"
          id="WorkingExperienceInfoModalBody-id"
          // style={{width: '100vw'}}
        >
         <WorkingExperienceLayout/>
        </Modal.Body>
        <Modal.Footer
          className="modal-footer"
         
        >
          <div className="modal-got-it-btn-div">
            <Button
              
              onClick={props.onHide}
            >
              GOT IT!
            </Button>
          </div>
          {/* <button  onClick={props.onHide}>CLOSE</button> */}
        </Modal.Footer>
        {/* </Modal.Dialog> */}
      </Modal>
    </>
  );
}

export default WorkExperienceInfoModal;